<template>
    <div>
        <div class="card mb-2" v-for="(item, index) in items" :key="index">
            <div class="card-body p-3">
                <div class="row align-items-center">
                    <div class="col" v-for="(column, index) in columns" :key="index">
                        <i v-if="column.icon" class="mr-2 fe " :class="column.icon(item)"></i>
                        <span>{{column.field(item)}}</span>
                        <br/>
                        <span v-if="column.subfield" class="small text-muted">{{column.subfield(item)}}</span>
                    </div>
                    <div class="col-auto text-center small">
                        <span>{{item.updatedAt | moment("H:MM, DD/MM/YYYY")}}</span>
                    </div>
                    <div class="col-auto">
                        <button
                            class="btn btn-white btn-sm mr-3"
                            v-b-tooltip
                            :title="$t('Recover')"
                            @click="recover(item)">
                            <i class="fe fe-rotate-ccw"></i>
                        </button>
                        <confirmable-button
                            style="display:inline-block; padding: 2px 6px 2px 6px"
                            v-b-tooltip
                            :title="$t('Permanently delete')"
                            @confirm="permanentDelete(item)"
                        >
                            <i class="fe fe-trash text-danger"></i>
                        </confirmable-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-inactive" v-if="!items.length">
            <div class="card-body text-muted text-center small">
                <span>{{$t('Nothing yet')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {modalMixins} from '@/mixins/modal.js'
    import ConfirmableButton from '@/components/ConfirmableButton.vue'

    export default {
        components: {ConfirmableButton},
        mixins: [modalMixins],
        props: {items: null, columns: null, recoverItem: null, deleteItem: null},
        data() {
            return {
                selected: {}
            }
        },
        name: "TrashPage",
        methods: {
            recover(item) {
                const patchFunc = this.recoverItem(item);
                patchFunc([item._id, {deleted: false}]).then(() => {
                    this.$toasted.global.success({
                        message: this.$t('Successfully recovered')
                    });
                }).catch(e => {
                    this.$toasted.global.error({
                        message: this.$t('Failed to recover') + '. ' + this.$t(e.message)
                    })
                })
            },

            permanentDelete(item) {
                const deleteFunc = this.deleteItem(item);
                deleteFunc([item._id, {query: {permanently: true}}]).then(() => {
                    this.$toasted.global.success({
                        message: this.$t('Permanently deleted')
                    });
                });
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>
